import Snackbar from '@mui/material/Snackbar';
import { Warning } from '@mui/icons-material';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
export default function UtilToastMessages({ isOpen, handleClose, data, severity }) {


  return (
    <div style={{ borderRadius: '15px' }}>
      <Snackbar
        open={isOpen}
        autoHideDuration={3000}
        severity="success"
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handleClose}
      >

        <div style={{ display: "flex", width: "100%", borderRadius: '15px', minWidth: "300px" }}>
          <div style={{ padding: "5px", background: `${severity ? severity === "warning" ? "orange" : "green" : "red"}`, borderRadius: '5px 0px 0px 5px' }}>
            {severity ? severity === "warning" ? <Warning sx={{ color: 'white' }} /> : <CheckCircleIcon sx={{ color: 'white' }} /> : <ErrorIcon sx={{ color: 'white' }} />}
          </div>
          <div style={{ display: "flex", width: "100%", background: "white", color: "black", padding: "8px", borderRadius: '0px 5px 5px 0px', justifyContent: "center" }}>
            {data}
          </div>
        </div>

        {/* <SnackbarContent
          message={data}
          style={{
            backgroundColor: backgroundColor,
            color: color, 
          }}
        /> */}
      </Snackbar>
    </div>
  );
}